import { useQuery } from '@tanstack/react-query';
import axios, { AxiosResponse } from 'axios';
import { PlanningOrderStatisticsEntity } from 'src/entities/PlanningOrderStatistics.entity';

const getCollection = (startOn: string, endOn: string, orderIds: number[]) => async () => {
  const requestPath = `/api/v3/plannings/${startOn}/orders/statistics?end_on=${endOn}`;

  const response: AxiosResponse<PlanningOrderStatisticsEntity> = await axios.post(requestPath, {
    order_ids: orderIds
  });

  return response.data;
};

export const useQueryPlanningOrderStatistics = (startOn: string, endOn: string, orderIds: number[]) => useQuery({
  queryKey: ['useQueryPlanningOrderStatistics', { startOn, endOn, orderIds }],
  queryFn: getCollection(startOn, endOn, orderIds),
  staleTime: Infinity,
  enabled: Boolean(startOn) && Boolean(endOn)
});

const getStatistics = (startOn: string, endOn: string, ids: number[]) => async () => {
  const requestPath = `/api/v5/plannings/${startOn}/leg_run_statistics?end_on=${endOn}`;

  const response: AxiosResponse<PlanningOrderStatisticsEntity> = await axios.post(requestPath, {
    leg_run_ids: ids
  });

  return response.data;
}

export const useQueryPlanningsLegRunStatistics = (startOn: string, endOn: string, ids: number[]) => useQuery({
  queryKey: ['useQueryPlanningsLegRunStatistics', { startOn, endOn, ids }],
  queryFn: getStatistics(startOn, endOn, ids),
  staleTime: Infinity,
  enabled: Boolean(startOn) && Boolean(endOn),
});
